module.exports = __webpack_public_path__ + "static/brama_thumb-f75895a539fcdb3c55b6edbe7a42f6ac.jpg";